/** The address of a PDF download made to show in a page (`inline=1` makes the server answer with `inline` instead of `attachment`). */
export function inlineHref(href: string): string {
  return `${href}${href.includes("?") ? "&" : "?"}inline=1`;
}
